/**
 * @file functional-requirement.tsx
 * @description Компонент страницы каталога функциональных требований для управления сущностями 
 * функциональных требований в системе управления задачами. Обеспечивает создание, редактирование и просмотр 
 * функциональных требований с поддержкой иерархических групп. Включает категоризацию по сервисам, 
 * отслеживание статусов и возможности фильтрации. Использует простой одновкладочный интерфейс, 
 * ориентированный на обзор и управление требованиями.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies ['@forms/functional-requirement', '@utils/table-view', '@features/filter/types', '@forms/functional-requirement/tabs']
 * @related-files ['@forms/functional-requirement/index.tsx', '@forms/functional-requirement/tabs/Main.tsx']
 */

import { FunctionalRequirementForm } from '@forms/functional-requirement';
import { getDefaultCell } from '@utils/table-view';
import { tabObject, TBaseObjectDto } from '@src/types';
import { filterComponent } from '@features/filter/types';
import { Main } from '@forms/functional-requirement/tabs';

export const title = 'Функциональные требования';
export const searchModalTitle = 'Выбор функционального требования';
export const type = 'FunctionalRequirement';
export const parentType = 'FunctionalRequirementGroup';
export const path = 'functional-requirement';
export const form = FunctionalRequirementForm;
export const isCanAddGroups = true;
export const tabs: tabObject[] = [
    { label: 'Обзор', component: Main }
];

export const columns = [
    {
        id: '$item',
        header: [{ text: 'Код' }],
        width: 140,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'state',
        header: [{ text: 'Статус' }],
        width: 143,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'name',
        header: [{ text: 'Наименование' }]
    },
    {
        id: 'service',
        header: [{ text: 'Сервис' }],
        width: 230
    }
];

export const getFilterControls = (data: TBaseObjectDto = {}): filterComponent[] => [
    {
        filterType: 'dictionary',
        filterProps: {
            label: 'Сервис',
            type: 'Service'
        },
        value: data.service,
        name: 'service',
        tab: 'filters'
    },
    {
        filterType: 'select',
        filterProps: {
            label: 'Статус',
            emptyItem: 'Все'
        },
        value: data.state,
        type: 'ETaskState',
        name: 'state',
        tab: 'filters'
    }
];
